import { render, staticRenderFns } from "./textfield.vue?vue&type=template&id=3fac1b0b&scoped=true&lang=pug&"
import script from "./textfield.vue?vue&type=script&lang=coffee&"
export * from "./textfield.vue?vue&type=script&lang=coffee&"
import style0 from "./textfield.vue?vue&type=style&index=0&id=3fac1b0b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fac1b0b",
  null
  
)

export default component.exports